import { useEffect, useState } from "react";
import { Button } from "./ui/button";

const CONSENT_KEY = "bizsarthi_analytics_consent_v1";
const DEFAULT_GOOGLE_ADS_ID = "AW-18247255508";
const configuredGoogleIds = new Set();

const setGoogleConsent = (value, command = "update") => {
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };
  const consent = {
    analytics_storage: value,
    ad_storage: value,
    ad_user_data: value,
    ad_personalization: value,
  };
  if (command === "default") consent.wait_for_update = 500;
  window.gtag("consent", command, consent);
};

const loadGoogleTag = () => {
  const ga4Id = process.env.REACT_APP_GA4_ID;
  const adsId =
    process.env.REACT_APP_GOOGLE_ADS_ID || DEFAULT_GOOGLE_ADS_ID;
  const measurementIds = [...new Set([ga4Id, adsId].filter(Boolean))];
  if (!measurementIds.length) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  if (!document.getElementById("bizsarthi-google-tag")) {
    const script = document.createElement("script");
    script.id = "bizsarthi-google-tag";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementIds[0])}`;
    document.head.appendChild(script);
    window.gtag("js", new Date());
  }

  measurementIds.forEach((measurementId) => {
    if (configuredGoogleIds.has(measurementId)) return;
    window.gtag("config", measurementId, {
      anonymize_ip: true,
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
      send_page_view: true,
    });
    configuredGoogleIds.add(measurementId);
  });
};

export const ConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = window.localStorage.getItem(CONSENT_KEY);
    const isAdsLandingPage = window.location.pathname.startsWith("/ads/");

    // Ads pages use advanced Consent Mode: the Google tag loads with denied
    // defaults, so consent-aware cookieless measurement can still work without
    // writing advertising or analytics cookies. Standard site pages retain the
    // existing consent behaviour.
    if (isAdsLandingPage) {
      setGoogleConsent("denied", "default");
      if (saved === "granted" || saved === "denied") {
        setGoogleConsent(saved);
      }
      loadGoogleTag();
      if (!saved) setVisible(true);
      return;
    }

    if (saved === "granted") {
      setGoogleConsent("granted");
    } else {
      setGoogleConsent("denied");
      if (!saved) setVisible(true);
    }
    loadGoogleTag();
  }, []);

  const choose = (value) => {
    window.localStorage.setItem(CONSENT_KEY, value);
    setGoogleConsent(value);
    if (value === "granted") {
      loadGoogleTag();
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <aside
      className="fixed inset-x-3 bottom-20 z-[90] mx-auto min-w-0 max-w-3xl overflow-hidden rounded-2xl border border-slate-200 bg-white p-4 shadow-2xl sm:bottom-5 sm:flex sm:items-center sm:justify-between sm:gap-5"
      aria-label="Analytics consent"
    >
      <div>
        <p className="font-semibold text-slate-900">Your privacy choices</p>
        <p className="mt-1 text-xs leading-relaxed text-slate-600">
          Essential website functions always work. Optional analytics help us
          understand enquiries and improve advertising performance.
        </p>
      </div>
      <div className="mt-3 flex min-w-0 flex-wrap gap-2 sm:mt-0 sm:shrink-0">
        <Button
          type="button"
          variant="outline"
          onClick={() => choose("denied")}
          className="min-w-0 flex-1 border-slate-300 px-3 text-slate-700 sm:flex-none"
        >
          Essential only
        </Button>
        <Button
          type="button"
          onClick={() => choose("granted")}
          className="min-w-0 flex-1 bg-emerald-600 px-3 text-white hover:bg-emerald-700 sm:flex-none"
        >
          Allow analytics
        </Button>
      </div>
    </aside>
  );
};
 
